export default __webpack_public_path__ + "static/media/google-img.a34b5f01.png";